export default __webpack_public_path__ + "static/media/img-60.eb387ce9.jpg";